/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const VolumeMaxIcon = /*#__PURE__*/ createSvgIcon(
  'VolumeMaxIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M15.5 9.986a5.25 5.25 0 00-.896-2.976 5.609 5.609 0 00-2.35-2.017.925.925 0 01-.441-.42.64.64 0 01-.021-.573.753.753 0 01.448-.438.803.803 0 01.635.013 6.757 6.757 0 013.01 2.581A6.984 6.984 0 0117 10.003c0 1.404-.372 2.682-1.115 3.833a6.783 6.783 0 01-3.01 2.569.803.803 0 01-.635.012.754.754 0 01-.448-.438.64.64 0 01.02-.573.925.925 0 01.441-.42 5.6 5.6 0 002.351-2.02 5.265 5.265 0 00.896-2.98zM6 12H3.75a.726.726 0 01-.534-.216A.726.726 0 013 11.25v-2.5c0-.213.072-.39.216-.534A.726.726 0 013.75 8H6l2.73-2.73c.235-.235.506-.288.812-.156.305.13.458.365.458.703v8.364c0 .338-.153.573-.458.704-.306.132-.577.08-.813-.156L6 12zm7.5-2c0 .514-.125 1.042-.375 1.583-.25.542-.604.952-1.063 1.23a.38.38 0 01-.374.01c-.126-.063-.188-.174-.188-.333V7.51c0-.16.063-.27.188-.333a.38.38 0 01.374.01c.459.264.813.67 1.063 1.22.25.548.375 1.08.375 1.593zm-5-2.375L6.625 9.5H4.5v1h2.125L8.5 12.375v-4.75z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default VolumeMaxIcon;
